import { rem } from "@affinity/constants/StyleHelpers";

export const buttonSizeVariants = {
    small: {
        fontSize: rem(16),
        padding: `${rem(16)} ${rem(24)}`,
        iconPadding: rem(10),
    },
    medium: {
        fontSize: rem(16),
        padding: `${rem(16)} ${rem(24)}`,
        iconPadding: rem(10),
    },
    large: {
        fontSize: rem(18),
        padding: `${rem(20)} ${rem(24)}`,
        iconPadding: rem(10),
    },
};